import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { dividendReInvestActions } from '../+state/dividend-re-invest.actions';
import { dividendReInvestFeature } from '../+state/dividend-re-invest.reducer';

@Injectable({ providedIn: 'root' })
export class DividendReInvestFacade {
  readonly #store: Store = inject(Store);

  public readonly hasActivated$ = this.#store.select(dividendReInvestFeature.selectHasActivated);
  public readonly isVisible$ = this.#store.select(dividendReInvestFeature.selectIsVisible);
  public readonly hasOngoingRequest$ = this.#store.select(dividendReInvestFeature.selectHasOngoingRequest);
  public readonly error$ = this.#store.select(dividendReInvestFeature.selectError);
  public readonly hasChosen$ = this.#store.select(dividendReInvestFeature.selectHasChosen);
  public readonly currentSettings$ = this.#store.select(dividendReInvestFeature.selectCurrentSettings);

  public decline = () => this.#store.dispatch(dividendReInvestActions.decline());
  public activate = (amountFrom: number) => this.#store.dispatch(dividendReInvestActions.activate({ amountFrom }));
  public close = () => this.#store.dispatch(dividendReInvestActions.close());
  public loadCurrentSettings = () => this.#store.dispatch(dividendReInvestActions.loadCurrentSettings());
}
